import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 flex items-center justify-center px-4 py-16">
      <div className="max-w-2xl w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-32 h-32 bg-teal-50 rounded-full mb-6">
            <i className="ri-emotion-sad-line text-6xl text-teal-600"></i>
          </div>
          <h1 className="text-8xl font-black text-gray-200 mb-4">404</h1>
          <h2 className="text-3xl font-bold text-gray-800 mb-3">Seite nicht gefunden</h2>
          <p className="text-lg text-gray-600 mb-8">
            Die gesuchte Seite existiert leider nicht oder wurde verschoben.
          </p>
        </div>

        {/* Quick Links */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-6">Hilfreiche Links:</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Link 
              to="/" 
              className="flex items-center gap-3 p-4 bg-gray-50 hover:bg-teal-50 rounded-xl transition-all duration-300 group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-teal-100 group-hover:bg-teal-600 rounded-lg transition-colors">
                <i className="ri-home-4-line text-xl text-teal-600 group-hover:text-white"></i>
              </div>
              <div className="text-left">
                <div className="font-semibold text-gray-800">Startseite</div>
                <div className="text-sm text-gray-500">Zurück zur Hauptseite</div>
              </div>
            </Link>

            <Link 
              to="/beduerfnisse" 
              className="flex items-center gap-3 p-4 bg-gray-50 hover:bg-teal-50 rounded-xl transition-all duration-300 group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-teal-100 group-hover:bg-teal-600 rounded-lg transition-colors">
                <i className="ri-heart-pulse-line text-xl text-teal-600 group-hover:text-white"></i>
              </div>
              <div className="text-left">
                <div className="font-semibold text-gray-800">Bedürfnisse</div>
                <div className="text-sm text-gray-500">Hilfe für Ihren Senior</div>
              </div>
            </Link>

            <Link 
              to="/ratgeber" 
              className="flex items-center gap-3 p-4 bg-gray-50 hover:bg-teal-50 rounded-xl transition-all duration-300 group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-teal-100 group-hover:bg-teal-600 rounded-lg transition-colors">
                <i className="ri-book-open-line text-xl text-teal-600 group-hover:text-white"></i>
              </div>
              <div className="text-left">
                <div className="font-semibold text-gray-800">Ratgeber</div>
                <div className="text-sm text-gray-500">Wissenswertes & Tipps</div>
              </div>
            </Link>

            <Link 
              to="/ueber-hund-im-alter" 
              className="flex items-center gap-3 p-4 bg-gray-50 hover:bg-teal-50 rounded-xl transition-all duration-300 group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-teal-100 group-hover:bg-teal-600 rounded-lg transition-colors">
                <i className="ri-information-line text-xl text-teal-600 group-hover:text-white"></i>
              </div>
              <div className="text-left">
                <div className="font-semibold text-gray-800">Über uns</div>
                <div className="text-sm text-gray-500">Unsere Mission</div>
              </div>
            </Link>
          </div>
        </div>

        {/* Back Button */}
        <button 
          onClick={() => window.history.back()}
          className="inline-flex items-center gap-2 px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-semibold rounded-xl transition-colors whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          Zurück zur vorherigen Seite
        </button>
      </div>
    </div>
  );
}
